// The workspace members, read once per workspace and shared (names for "Anna works on sets", crew pickers).
import { useEffect, useState } from "react";
import type { Api } from "../api.ts";
import { type Member, memberName, reviewApi } from "../collab/reviewApi.ts";
import type { Person } from "./steps.ts";

const cache = new Map<string, Promise<Member[]>>();

export function loadMembers(api: Api, ws: string): Promise<Member[]> {
  let p = cache.get(ws);
  if (!p) {
    p = reviewApi(api, ws)
      .members()
      .then((r) => r.items);
    cache.set(ws, p);
    p.catch(() => cache.delete(ws));
  }
  return p;
}

export const toPeople = (members: readonly Member[]): Person[] =>
  members.map((m) => ({ id: m.user_id, name: memberName(m), role: m.role }));

/** The members of the workspace as people (id, name, role); empty until they arrive or when they cannot load. */
export function usePeople(api: Api, ws: string): Person[] {
  const [people, setPeople] = useState<Person[]>([]);
  useEffect(() => {
    let live = true;
    loadMembers(api, ws).then(
      (m) => live && setPeople(toPeople(m)),
      () => undefined,
    );
    return () => {
      live = false;
    };
  }, [api, ws]);
  return people;
}
